import { getIotCoverage } from '@/services/iot.service'
import { defineStore } from 'pinia'
import { onMounted, ref } from 'vue'

export const useIotCoverageStore = defineStore('iot-coverage', () => {
  const complexes = ref<string[]>([])
  const constructions = ref<string[]>([])
  const levels = ref<string[]>([])

  const alreadyInitialized = ref(false)

  async function init() {
    if (alreadyInitialized.value) return
    alreadyInitialized.value = true
    const now = new Date()
    const yesterday = new Date(Date.now() - 24 * 60 * 1000)
    let response
    try {
      response = await getIotCoverage({
        from: yesterday.toISOString().substring(0, 10),
        to: now.toISOString().substring(0, 10),
        onlyBusinessHours: false,
        onlyBusinessDays: false
      })
    } catch (e) {
      // Fired on mount for everyone; a caller without IoT access (e.g. a license admin who isn't a
      // member, ZDB-7393) gets a 403. No coverage then, not an unhandled rejection.
      console.error('useIotCoverageStore: failed to fetch IoT coverage', e)
      // Not initialized after all: the next init() tries again.
      alreadyInitialized.value = false
      return
    }
    complexes.value = response.optionsWithData.complexes
    constructions.value = response.optionsWithData.constructions
    levels.value = response.optionsWithData.levels
  }

  onMounted(() => init())

  return {
    complexes,
    constructions,
    levels,
    init
  }
})
